import React, { useEffect, useState } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function TestimonyHistory() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [testimonies, setTestimonies] = useState([]);
  const [loading, setLoading] = useState(true);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);


  const getInitials = (name) => {
    if (!name) return "A";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };


  useEffect(() => {
    const fetchTestimonies = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        toast.error("You must be logged in to view your testimonies.", {
          theme: "colored",
        });
        setLoading(false);
        return;
      }

      try {
       const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
        const res = await fetch(
          `${TEST_BASE_URL}/testimonies`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        if (res.ok && data.status === "success") {
          setTestimonies(Array.isArray(data.data) ? data.data : []);
        } else {
          toast.error(data.message || "Failed to load testimonies.", {
            theme: "colored",
          });
        }
      } catch (err) {
        console.error("Error fetching testimonies:", err);
        toast.error("Network error — please try again.", { theme: "colored" });
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonies();
  }, []);

  
  useEffect(() => {
    if (testimonies.length > 0) {
      const cards = document.querySelectorAll(".request-card");
      let maxHeight = 0;

    
      cards.forEach((card) => {
        card.style.height = "auto";
        maxHeight = Math.max(maxHeight, card.offsetHeight);
      });

   
      cards.forEach((card) => {
        card.style.height = `${maxHeight}px`;
      });
    }
  }, [testimonies]);

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div
          className={`bottom-content ${
            loading || testimonies.length === 0 ? "full-height" : "fit-height"
          }`}
        >
          <h5>Your Testimonies History</h5>

          {loading ? (
            <p>Loading testimonies...</p>
          ) : testimonies.length === 0 ? (
            <p>No testimonies found yet.</p>
          ) : (
            <div className="row">
              {testimonies.map((item, index) => {
                const avatarUrl = item.avatar
                  ? `https://rccgbournemouth.org/storage/${item.avatar}`
                  : null;

                return (
                  <div className="col-md-4 mb-4" key={index}>
                    <div
                      className="request-card"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "1rem",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                        background: "white",
                      }}
                    >
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          background: "#0045e8",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "20px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        {avatarUrl && !item.is_shared_anonymously ? (
                          <img
                            src={avatarUrl}
                            alt={item.name || "Anonymous"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.style.display = "none";
                              e.target.parentNode.textContent = getInitials(
                                item.name
                              );
                            }}
                          />
                        ) : (
                          getInitials(item.name)
                        )}
                      </div>

                      <p>
                        <small>{item.message}</small>
                      </p>

                      <p>
                        <small
                          style={{
                            color: item.show_as_featured
                              ? "#20A100"
                              : "#A10000",
                            fontWeight: "bold",
                          }}
                        >
                          {item.show_as_featured
                            ? "ADDED TO FEATURES"
                            : "NOT ADDED TO FEATURES"}
                        </small>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default TestimonyHistory;
